/* eslint-disable import/no-anonymous-default-export */
import { exeRequest } from '../utils/APIUtils';

export default {
    // --- STATISTIQUES ---
    getStats: async () => await exeRequest("/admin/ambassadors/stats", "GET"),

    // --- LISTE & DETAIL ---
    getAmbassadors: async (params = {}) => {
        const queryParams = new URLSearchParams(params).toString();
        return await exeRequest(`/admin/ambassadors${queryParams ? `?${queryParams}` : ''}`, "GET");
    },

    getAmbassadorById: async (id) => await exeRequest(`/admin/ambassadors/${id}`, "GET"),

    // --- CREATION ---
    createAmbassador: async (data) => await exeRequest("/admin/ambassadors", "POST", data),

    // --- MODIFICATION ---
    updateAmbassador: async (id, data) => await exeRequest(`/admin/ambassadors/${id}`, "PUT", data),

    // --- GESTION DU STATUT ---
    approveAmbassador: async (id) => await exeRequest(`/admin/ambassadors/${id}/approve`, "PATCH"),

    suspendAmbassador: async (id, reason) => await exeRequest(`/admin/ambassadors/${id}/suspend`, "PATCH", { reason }),

    reactivateAmbassador: async (id) => await exeRequest(`/admin/ambassadors/${id}/reactivate`, "PATCH"),

    deleteAmbassador: async (id) => await exeRequest(`/admin/ambassadors/${id}`, "DELETE"),

    // --- GESTION DES VEHICULES ---
    getAvailableVehicles: async (params = {}) => {
        const queryParams = new URLSearchParams(params).toString();
        return await exeRequest(`/admin/ambassadors/available-vehicles${queryParams ? `?${queryParams}` : ''}`, "GET");
    },

    linkVehicle: async (ambassadorId, vehicleId) => await exeRequest(`/admin/ambassadors/${ambassadorId}/link-vehicle`, "POST", { vehicleId }),

    unlinkVehicle: async (ambassadorId, vehicleId) => await exeRequest(`/admin/ambassadors/${ambassadorId}/unlink-vehicle/${vehicleId}`, "DELETE"),

    // --- GESTION DES CHAUFFEURS ---
    getAvailableDrivers: async (params = {}) => {
        const queryParams = new URLSearchParams(params).toString();
        return await exeRequest(`/admin/ambassadors/available-drivers${queryParams ? `?${queryParams}` : ''}`, "GET");
    },

    linkDriver: async (ambassadorId, driverId) => await exeRequest(`/admin/ambassadors/${ambassadorId}/link-driver`, "POST", { driverId }),

    unlinkDriver: async (ambassadorId, driverId) => await exeRequest(`/admin/ambassadors/${ambassadorId}/unlink-driver/${driverId}`, "DELETE"),

    // Créer un chauffeur directement pour un ambassadeur
    createDriverForAmbassador: async (ambassadorId, driverData) =>
        await exeRequest(`/admin/ambassadors/${ambassadorId}/create-driver`, "POST", driverData),

    // --- GESTION DES AFFILIES ---
    getAvailableAffiliates: async (params = {}) => {
        const queryParams = new URLSearchParams(params).toString();
        return await exeRequest(`/admin/ambassadors/available-affiliates${queryParams ? `?${queryParams}` : ''}`, "GET");
    },

    linkAffiliate: async (ambassadorId, affiliateId) =>
        await exeRequest(`/admin/ambassadors/${ambassadorId}/link-affiliate`, "POST", { affiliateId }),

    unlinkAffiliate: async (ambassadorId, affiliateId) =>
        await exeRequest(`/admin/ambassadors/${ambassadorId}/unlink-affiliate/${affiliateId}`, "DELETE"),

    // Créer un affilié directement pour un ambassadeur
    createAffiliateForAmbassador: async (ambassadorId, affiliateData) =>
        await exeRequest(`/admin/ambassadors/${ambassadorId}/create-affiliate`, "POST", affiliateData),

    // --- CANDIDATURES ---
    getApplications: async (params = {}) => {
        const queryParams = new URLSearchParams(params).toString();
        return await exeRequest(`/admin/ambassador-applications${queryParams ? `?${queryParams}` : ''}`, "GET");
    },

    getApplicationById: async (id) => await exeRequest(`/admin/ambassador-applications/${id}`, "GET"),

    approveApplication: async (id) => await exeRequest(`/admin/ambassador-applications/${id}/approve`, "PATCH"),

    rejectApplication: async (id, reason) => await exeRequest(`/admin/ambassador-applications/${id}/reject`, "PATCH", { reason }),

    deleteApplication: async (id) => await exeRequest(`/admin/ambassador-applications/${id}`, "DELETE"),
};
